import React, { useEffect } from "react";
import PrivacyPolicyDialog, {
  PrivacyPolicyContent,
} from "../../components/Dialogs/PrivacyPolicy/index";
import CreateProfile, {
  CreateProfileContent,
} from "../../components/Dialogs/CreateProfile/index";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import HelpIcon from "@mui/icons-material/Help";
import { useNavigate } from "react-router-dom";
import FacebookLogin from "@greatsumini/react-facebook-login";
import "./styles.scss";
import "./../../assets/css/_global.scss";
import Logo from "./../../assets/images/generic/logo.jpg";
import GenericContent from "../../services/GenericContent";
import ContentTypes from "../../services/Content";
import UserSession from "../../services/UserSession";
import GameApi from "../../services/GameApi";
import GameHelper from "../../services/GameHelper";
import { Parser } from "html-to-react";
import {
  ButtonTypes,
  CommonContent,
  Content,
  ContentKey,
  Language,
  TranslatableImagesTypes,
} from "../../types/Types";
import {
  getSelectedLanguage,
  saveSelectedLanguage,
} from "./../../services/Language";
import ContentUtil from "./../../util/Content";
import HomePageLoadingSkeleton from "../../components/Skeleton/HomeSkeleton";
import { FacebookUserProfile, PlayerDetails, SocialNetwork } from "../../types/Game";
import PopupLoading from "../../components/PopupLoading";
import PopupMessage from "../../components/PopupMessage";
import { API_URL } from "../../config/Constants";

const HomeScreen = () => {
  let isInviteChecked: boolean = false;
  let isChekingSession: boolean = false;

  const appId = process.env.REACT_APP_ENV
    ? "1590838211210835"
    : "1696091304687149";
  const navigate = useNavigate();

  const [loginMode, setLoginMode] = React.useState<SocialNetwork | null>(
    SocialNetwork.Anonymous
  );
  const [showRegistration, setShowRegistration] = React.useState(false);
  const [showPrivacyPolicy, setShowPrivacyPolicy] = React.useState(false);
  const [commonContent, setCommonContent] = React.useState<CommonContent[]>([]);
  const [players, setPlayers] = React.useState<PlayerDetails[]>([]);
  const [contentType, setContentType] = React.useState<Content[]>([]);
  const [socialLogin, setSocialLogin] = React.useState(false);
  const [gameInvite, setGameInvite] = React.useState(false);
  const [isSessionCheked, setIsSessionCheked] = React.useState(false);
  const [hasReachedMaxPlayers, setHasReachedMaxPlayers] = React.useState(false);

  const [privacyPolicy, setPrivacyPolicy] =
    React.useState<PrivacyPolicyContent>();
  const [createProfileContent, setCreateProfileContent] =
    React.useState<CreateProfileContent>();

  useEffect(() => {
    if (commonContent.length <= 0) {
      getContent();
      GameApi.cleanExpiredRecords()
        .then((res) => {
          console.log(res);
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }, [commonContent]);

  useEffect(() => {
    if (isSessionCheked === false) {
      checkSesson()
        .then(() => {})
        .catch((e) => {
          console.error(e);
        });
    }
  }, [isSessionCheked]);

  const switchLang = (lan: Language) => {
    saveSelectedLanguage(lan);
    getContent(true);
  };

  const getContent = (refresh?: boolean) => {
    GenericContent.getContent(refresh).then((commonContent) => {
      ContentTypes.getContent().then((content) => {
        setPrivacyPolicy(
          ContentUtil.toPrivacyPolicyContent(content, commonContent)
        );
        setContentType(content);
      });
      setCommonContent(commonContent);
      toProfileContent(commonContent);
    });
  };

  const getLanguageVariant = (lan: Language) => {
    return getSelectedLanguage() === lan ? "contained" : "outlined";
  };

  const toProfileContent = (commonContent: CommonContent[]) => {
    const continueB = GenericContent.getButtonName(
      commonContent,
      ButtonTypes.CONTINUE
    );

    const title = GenericContent.getKeyValue(
      commonContent,
      ContentKey.CREATE_PROFILE
    );
    const description = GenericContent.getKeyValue(
      commonContent,
      ContentKey.CREATE_PROFILE_DESCRIPTION
    );
    const nickNameDescription = GenericContent.getKeyValue(
      commonContent,
      ContentKey.NAME
    );

    const profileContent: CreateProfileContent = {
      title,
      description,
      continue: continueB,
      nickNameDescription,
    };

    setCreateProfileContent(profileContent);
  };

  const navigateToHowToplay = () => {
    navigate("/howtoplay", {
      replace: true,
      state: {
        homePage: true,
      },
    });
  };

  const navigateToGameMode = () => {
    navigate("/game-mode", { replace: true });
  };

  const starSesson = async (user: FacebookUserProfile) => {
    const res = await UserSession.startSessionWithFacebook(user);
  };

  const navigateAfterPrivicyPolicy = async () => {
    setShowPrivacyPolicy(false);
    if (loginMode === SocialNetwork.Anonymous) {
      setShowRegistration(true);
    } else {
      navigateToGameMode();
    }
  };

  const delayAsyncCall = (ms: number): Promise<void> =>
    new Promise((resolve) => {
      setTimeout(resolve, ms);
    });

  const checkSesson = async () => {
    if (!isChekingSession) {
      isChekingSession = true;
      await checkInvite();
      const isUserLoggedIn = await UserSession.isUserLoggedIn();
      if (isUserLoggedIn && !privacyPolicy) {
        navigateToGameMode();
      }
      isChekingSession = false;
      setIsSessionCheked(true);
    }
  };

  const checkInvite = async () => {
    try {
      const params = new URLSearchParams(window.location.search);
      const gameId = params.get("gameId");
      if (gameId) {
        setGameInvite(true);
        const players = await GameHelper.getPlayerInGame(gameId);
        setPlayers(players);
        setHasReachedMaxPlayers(false);
        if (players.length <= 4) {
          await GameHelper.saveGameInvite(gameId);
          const isUserLoggedIn = await UserSession.isUserLoggedIn();
          if (isUserLoggedIn && !isInviteChecked) {
            isInviteChecked = true;
            await GameHelper.joinToGame();
            //navigate("/game", { replace: true });
          }
        } else {
          setHasReachedMaxPlayers(true);
        }
        setGameInvite(false);
      }
    } catch (e) {
      setGameInvite(false);
      console.error(e);
    }
  };

  return (
    <div className="contenedorHome">
      {commonContent.length > 0 ? (
        <>
          <div className="homeTopButtons">
            <Button
              variant={getLanguageVariant(Language.ENGLISH)}
              onClick={() => switchLang(Language.ENGLISH)}
            >
              {GenericContent.getKeyValue(commonContent, ContentKey.ENGLISH)}
            </Button>
            <Button
              variant={getLanguageVariant(Language.ESPANISH)}
              onClick={() => switchLang(Language.ESPANISH)}
            >
              {GenericContent.getKeyValue(commonContent, ContentKey.SPANISH)}
            </Button>
            <Button
              variant={getLanguageVariant(Language.FRENCH)}
              onClick={() => switchLang(Language.FRENCH)}
            >
              {GenericContent.getKeyValue(commonContent, ContentKey.FRENCH)}
            </Button>
            <IconButton
              onClick={() => navigateToHowToplay()}
              sx={{ color: "#26576d" }}
              aria-label="help"
              component="label"
            >
              <HelpIcon fontSize="large" />
            </IconButton>
          </div>
          <img className="homeLogo" src={Logo}></img>
          <div className="homeLoginButtons">
            <FacebookLogin
              fields="name,email,picture"
              scope="public_profile"
              initParams={{
                version: "v10.0",
                xfbml: true,
              }}
              loginOptions={{
                return_scopes: true,
              }}
              children={GenericContent.getKeyValue(
                commonContent,
                ContentKey.FACEBOOK_LOGIN
              )}
              language="es_CO"
              appId={appId}
              onSuccess={(response) => {
                setLoginMode(SocialNetwork.Facebook);
                setSocialLogin(true);
                console.log("Login Success!", response);
              }}
              onFail={(error) => {
                console.log("Login Failed!", error);
              }}
              onProfileSuccess={async (response) => {
                setLoginMode(SocialNetwork.Facebook);
                console.log("Get Profile Success!", response);
                await starSesson(response as unknown as FacebookUserProfile);
                setSocialLogin(false);
                setShowPrivacyPolicy(true);
              }}
              style={{
                marginTop: "0px",
                backgroundColor: "#4267b2",
                color: "#fff",
                fontSize: "1.2em",
                padding: "15px 25px",
                border: "none",
                borderRadius: "4px",
              }}
            />
            <br></br>
            <Button
              onClick={() => {
                setLoginMode(SocialNetwork.Anonymous);
                setShowPrivacyPolicy(true);
              }}
              variant="outlined"
            >
              {Parser().parse(
                GenericContent.getKeyValue(
                  commonContent,
                  ContentKey.ANONYMOUS_LOGIN
                )
              )}
            </Button>
          </div>
          <div className="homeProjectOwner">
            <div>
              {GenericContent.getKeyValue(
                commonContent,
                ContentKey.PROJECT_DEVELOPER
              )}
              :
            </div>
            <img
              src={
                API_URL +
                GenericContent.filterByImageKey(
                  commonContent,
                  TranslatableImagesTypes.OWNER_LOGO
                )?.image
              }
            ></img>
          </div>
          <div className="homeProjectSponsors">
            <div>
              {GenericContent.getKeyValue(
                commonContent,
                ContentKey.IN_ALLIANCE_WITH
              )}
              :
            </div>
            <img
              src={
                API_URL +
                GenericContent.filterByImageKey(
                  commonContent,
                  TranslatableImagesTypes.IN_ALLIANCE_WITH
                )?.image
              }
            ></img>
          </div>
          <div className="homeProjectSponsors">
            <div>
              {GenericContent.getKeyValue(
                commonContent,
                ContentKey.PROJECT_SPONSOR
              )}
              :
            </div>
            <img
              src={
                API_URL +
                GenericContent.filterByImageKey(
                  commonContent,
                  TranslatableImagesTypes.SPONSORS
                )?.image
              }
            ></img>
          </div>
          <PopupMessage
            ok={GenericContent.getKeyValue(commonContent, ContentKey.OK_LABEL)}
            visible={hasReachedMaxPlayers}
            onConfirm={() => {
              setHasReachedMaxPlayers(false);
            }}
            description={GenericContent.getKeyValue(
              commonContent,
              ContentKey.GAME_HAS_REACHED_MAX_PLAYERS
            )}
          />
          <PopupLoading
            title={GenericContent.getKeyValue(
              commonContent,
              ContentKey.FACEBOOK_LOGIN
            )}
            visible={socialLogin}
            description=""
          />
          <PopupLoading
            title={GenericContent.getKeyValue(
              commonContent,
              ContentKey.GAME_INVITE
            )}
            visible={gameInvite}
            description=""
          />
          {privacyPolicy && (
            <PrivacyPolicyDialog
              data={privacyPolicy}
              onClose={() => {
                setShowPrivacyPolicy(false);
              }}
              show={showPrivacyPolicy}
              onContinue={() => {
                navigateAfterPrivicyPolicy();
              }}
            />
          )}
          {createProfileContent && (
            <CreateProfile
              players={players}
              content={createProfileContent}
              onClose={() => {
                setShowRegistration(false);
              }}
              show={showRegistration}
            />
          )}
        </>
      ) : (
        <HomePageLoadingSkeleton />
      )}
    </div>
  );
};
export default HomeScreen;
